import { render, staticRenderFns } from "./ManageRelationship.vue?vue&type=template&id=4cc4aac2&scoped=true"
import script from "./ManageRelationship.vue?vue&type=script&lang=js"
export * from "./ManageRelationship.vue?vue&type=script&lang=js"
import style0 from "./ManageRelationship.vue?vue&type=style&index=0&id=4cc4aac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4aac2",
  null
  
)

export default component.exports